export interface DescriptionDialogElement {
  key?: string;
  title: string;
  titleBold?: string;
  description: string;
  youtubeLink?: string;
}
